import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=def812d4&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&lang=ts"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=def812d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def812d4",
  null
  
)

export default component.exports